import { composeReducers } from 'common/util/composeReducers';
import {
    REQUESTING_BINDER_EXPORT,
    BINDER_EXPORT_REQUESTED,
    BINDER_EXPORT_REQUEST_FAILED
} from 'common/actions/binderExportActions';

export function requestingBinderExportReducer(state, action) {
    if (action && action.type !== REQUESTING_BINDER_EXPORT) {
        return state;
    }

    return {
        ...state,
        binderExport: {
            ...state.binderExport,
            isRequesting: true
        }
    };
}

export function binderExportRequestedReducer(state, action) {
    if (action && action.type !== BINDER_EXPORT_REQUESTED) {
        return state;
    }

    return {
        ...state,
        binderExport: {
            ...state.binderExport,
            isRequesting: false
        }
    };
}

export function binderExportRequestFailedReducer(state, action) {
    if (action && action.type !== BINDER_EXPORT_REQUEST_FAILED) {
        return state;
    }

    return {
        ...state,
        binderExport: {
            ...state.binderExport,
            isRequesting: false
        }
    };
}

export default composeReducers(
    requestingBinderExportReducer,
    binderExportRequestedReducer,
    binderExportRequestFailedReducer
);
